import React from 'react';
import { useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import { Alert } from 'antd';
// Api
import { GET_TICKETING_SETTING } from 'api/ticketing/queries';
// Types
import { GetTicketingSetting } from 'api/ticketing/types/GetTicketingSetting';
// Constants
import { TICKETING_SETTINGS } from 'constants/routes';

type TicketingStatusAlertProps = {
  className?: string;
};

const TicketingStatusAlert = ({
  className,
}: TicketingStatusAlertProps): JSX.Element | null => {
  const { data } = useQuery<GetTicketingSetting>(GET_TICKETING_SETTING, {
    fetchPolicy: 'cache-and-network',
  });

  const setting = data?.getTicketingSetting;

  if (!setting) {
    return null;
  }

  const problems = [
    !setting.isEnabled &&
      'Ticketing is off: nobody can create or change events, tiers or comps.',
    setting.isEnabled &&
      !setting.salesEnabled &&
      'Sales are off: buyers cannot start a checkout.',
    !setting.workersEnabled &&
      'Background work is off: payments, refunds and emails are not processed.',
    !setting.gateEnabled && 'The gate is off: door staff cannot scan tickets.',
  ].filter((problem): problem is string => Boolean(problem));

  if (!problems.length) {
    return null;
  }

  return (
    <Alert
      className={className}
      type={setting.isEnabled ? 'warning' : 'error'}
      showIcon
      message={problems.length === 1 ? problems[0] : 'Ticketing is limited'}
      description={
        <>
          {problems.length > 1 && (
            <ul>
              {problems.map((problem) => (
                <li key={problem}>{problem}</li>
              ))}
            </ul>
          )}
          <Link to={TICKETING_SETTINGS}>Open ticketing settings</Link>
        </>
      }
    />
  );
};

export default TicketingStatusAlert;
